(() => {
  const $ = (sel, ctx=document) => ctx.querySelector(sel);
  const $$ = (sel, ctx=document) => Array.from(ctx.querySelectorAll(sel));
  const fmt = (cents, currency="USD") =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency }).format((cents||0)/100);

  const root = document;
  const openBtnSel = '[data-cb-open-pricing]';
  const modal = () => $('#cb-pricing-modal');

  function readData() {
    try {
      const json = JSON.parse($('#cb-pricing-data').textContent);
      // Normalize: if any price is 0 (missing handle), mark item unavailable
      json.items = json.items.map(it => ({...it, available: (it.price_cents||0) > 0, qty: 0}));
      return json;
    } catch(e){ console.error('[cb-pricing] bad data', e); return null; }
  }

  function tierForCount(tiers, count){
    for (const t of tiers){
      const maxOk = (t.max === null) ? true : (count <= t.max);
      if (count >= t.min && maxOk) return t;
    }
    return tiers[0]; // fallback
  }

  function renderRows(state){
  const rowsEl = document.getElementById('cb-pricing-rows');
  rowsEl.innerHTML = '';

  state.items.forEach((it) => {
    const row = document.createElement('div');
    row.className = 'cb-pricing-row';
    row.setAttribute('role','row');

        // Row 1: Name + Base (single line)
    const nameLine = document.createElement('div');
    nameLine.className = 'cb-line cb-line--name';

    const name = document.createElement('div');
    name.className = 'cb-cell cb-name';

    const itemName = document.createElement('span');
    itemName.className = 'cb-item-name';
    itemName.textContent = it.label + (it.available ? '' : ' (set handle)');

    const baseInline = document.createElement('span');
    baseInline.className = 'cb-base-inline';

    const baseText = it.available ? fmt(it.price_cents, state.currency) : '—';
    baseInline.append(' (', baseText, ' ');

    const baseWord = document.createElement('span');
    baseWord.className = 'cb-base-word';
    baseWord.textContent = 'base';

    baseInline.appendChild(baseWord);
    baseInline.append(')');

    name.appendChild(itemName);
    name.appendChild(baseInline);

    nameLine.appendChild(name);
    row.appendChild(nameLine);

    // Row 2: Qty | Subtotal (2-column)
    const metaLine = document.createElement('div');
    metaLine.className = 'cb-line cb-line--meta';
    metaLine.setAttribute('role','row');

    // Qty (left)
    const qty = document.createElement('div');
    qty.className = 'cb-cell cb-qty';
    qty.innerHTML = `
      <button type="button" class="cb-qty-btn" data-act="dec" aria-label="Decrease ${it.label}">−</button>
      <input type="number" inputmode="numeric" min="0" step="1" value="${it.qty}" aria-label="${it.label} quantity">
      <button type="button" class="cb-qty-btn" data-act="inc" aria-label="Increase ${it.label}">+</button>
    `;
    metaLine.appendChild(qty);

    // Subtotal (right)
    const sub = document.createElement('div');
    sub.className = 'cb-cell cb-right cb-sub';
    const subval = (it.qty || 0) * (it.price_cents || 0); // pre-discount
    sub.textContent = it.available ? fmt(subval, state.currency) : '—';
    metaLine.appendChild(sub);

    row.appendChild(metaLine);


    // Events
    const [decBtn, input, incBtn] = Array.from(qty.querySelectorAll('button, input'));
    decBtn.addEventListener('click', () => {
      input.value = Math.max(0, (+input.value||0) - 1);
      input.dispatchEvent(new Event('input', {bubbles:true}));
    });
    incBtn.addEventListener('click', () => {
      input.value = Math.max(0, (+input.value||0) + 1);
      input.dispatchEvent(new Event('input', {bubbles:true}));
    });
    input.addEventListener('input', () => {
      it.qty = Math.max(0, parseInt(input.value || '0', 10));
      update(state);
    });

    rowsEl.appendChild(row);
  });
}


  function update(state){
    // compute totals
    const count = state.items.reduce((n, it) => n + (it.qty||0), 0);
    const subCents = state.items.reduce((sum, it) => sum + (it.qty||0) * (it.price_cents||0), 0);
    const tier = tierForCount(state.tiers, count);

    // Update the "You're saving" chip (ARIA-live polite)
const chip = document.getElementById('cb-saving-chip');
if (chip) {
  const pct = Math.round((tier.discount || 0) * 100);
  chip.textContent = pct > 0 ? `You're saving ${pct}%` : 'No discount yet';
  chip.dataset.tier = String(pct);
}


    const discountCents = Math.round(subCents * (tier.discount || 0));
    const grandCents = Math.max(0, subCents - discountCents);

    // reflect line subtotals (pre-discount) for clarity
    $$('#cb-pricing-rows .cb-pricing-row').forEach((row, i) => {
      const it = state.items[i];
      const sub = row.querySelector('.cb-sub');
      const subval = (it.qty||0) * (it.price_cents||0);
      sub.textContent = it.available ? fmt(subval, state.currency) : '—';
    });

    // footer totals
    $('#cb-total-items').textContent = count;
    $('#cb-total-sub').textContent = fmt(subCents, state.currency);
    // Show tier percent instead of discount dollars
const pct = Math.round((tier.discount || 0) * 100);
$('#cb-total-discount').textContent = pct > 0 ? `${pct}% off` : '—';

    $('#cb-total-grand').textContent = fmt(grandCents, state.currency);

// free shipping badge (show only when total > $65)
const fs = $('#cb-free-ship');
if (fs) {
  fs.hidden = !(grandCents > state.free_shipping_cents);
}

  }

  function openModal(){
    const m = modal(); if (!m) return;
    m.hidden = false;
    document.documentElement.classList.add('cb-modal-open');
    $('.cb-pricing-close', m)?.focus();
  }
  function closeModal(){
    const m = modal(); if (!m) return;
    m.hidden = true;
    document.documentElement.classList.remove('cb-modal-open');
  }

  function copyEstimate(state){
    const count = state.items.reduce((n, it) => n + (it.qty||0), 0);
    const subCents = state.items.reduce((sum, it) => sum + (it.qty||0) * (it.price_cents||0), 0);
    const tier = tierForCount(state.tiers, count);
    const discountCents = Math.round(subCents * (tier.discount || 0));
    const grandCents = Math.max(0, subCents - discountCents);

    const lines = [];
    state.items.forEach(it => {
      if (it.qty > 0)
        lines.push(`${it.label}: ${it.qty} × ${fmt(it.price_cents, state.currency)} = ${fmt(it.qty * it.price_cents, state.currency)}`);
    });
    lines.push('');
    lines.push(`Items: ${count}`);
    lines.push(`Subtotal: ${fmt(subCents, state.currency)}`);
    lines.push(`Discount (${Math.round((tier.discount||0)*100)}%): -${fmt(discountCents, state.currency)}`);
    lines.push(`Total (before tax): ${fmt(grandCents, state.currency)}`);
    if (grandCents >= state.free_shipping_cents) lines.push(`Free Shipping reached ($${(state.free_shipping_cents/100).toFixed(2)}+)`);
    navigator.clipboard.writeText(lines.join('\n')).then(() => {
      // lightweight toast
      const btn = $('[data-cb-copy]');
      if (!btn) return;
      const prev = btn.textContent;
      btn.textContent = 'Copied!';
      setTimeout(()=>{ btn.textContent = prev; }, 1200);
    });
  }

  function init(){
    const state = readData();
    if (!state) return;

    // banner button
    root.addEventListener('click', (e) => {
      const openBtn = e.target.closest(openBtnSel);
      if (openBtn){
        openModal();
        window.Shopify?.analytics?.publish('pricing_calculator_open', {
          source_path: location.pathname,
          source_type: location.pathname.startsWith('/blogs/') ? 'blog' : 'site'
        });
      }
      if (e.target.closest('[data-cb-close]')){ closeModal(); }
      if (e.target.closest('[data-cb-copy]')){ copyEstimate(state); }
    });

    // close on ESC
    root.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeModal();
    });

    // initial render
    renderRows(state);
    update(state);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();